import { IKeyValuePair } from './../../../_models/common/common';
import { CommonService } from './../../../shared/services/common.service';
import { ISetting } from './../../../_models/cms/ISetting';
import { SettingService } from './../../../shared/services/setting.service';
import { ToastrService } from 'ngx-toastr';
import { PreferenceService } from './../../../shared/services/preference.service';
import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { IVacantPost } from './../../../_models/post-sections/IVacantPost';
import { IPreference } from './../../../_models/transfer-sections/IPreference';
import { VacantPostService } from './../../../shared/services/vacant-post.service';
import { IPaged } from './../../../_models/common/IPaged';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vacant-post',
  templateUrl: './vacant-post.component.html'
})
export class VacantPostComponent implements OnInit {
  @Output() onChangePreference = new EventEmitter();
  // @Input() id: number = 0;
  // @Input() profileId: string = '';
  // @Input() isTransfer: boolean = false;
  // @Input() isHardStation: boolean = false;
  skeleton: boolean = true;
  isSubmitEnable: boolean = false;
  loading: boolean;
  private readonly PAGE_SIZE = 10;
  title: string = 'Preferences';
  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    regionId: '',
    transferRequestId: '',
    id: 0,
    profileId: '',
    isTransfer: false,
    isHardStation: false,
  };

  queryPreference: any = {
    transferRequestId: '',
    sort: 'Order',
    sortDir: 'Ascending'
  };

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: false },
    { title: 'School', key: 'SchoolId', isSortable: false },
    { title: 'Designation', key: 'DesignationId', isSortable: false },
    { title: 'Type', key: 'VacancyTypeId', isSortable: false },
    { title: 'No Of Post', key: 'NoOfPost', isSortable: false },
    {}
  ];

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];

  transferRequest: ITransferRequest;
  preferences: IPreference[];
  setting: ISetting;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private service: VacantPostService,
    private transferRequestService: TransferRequestService,
    private preferenceService: PreferenceService,
    private commonService: CommonService,
    private settingService: SettingService) {

  }

  async ngOnInit() {

    this.setting = await this.settingService.getSetting();
    if (!this.setting.isTransfer) {
      this.toastrService.warning("transfer request module closed!");
      this.router.navigate(['/employee']);
    }

    this.bindDropDown();

    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.regionId = params.regionId ? params.regionId : '';
        this.query.id = params.id ? params.id : params.id;
        this.query.profileId = params.profileId ? params.profileId : params.profileId;
        this.query.isTransfer = params.isTransfer ? params.isTransfer : params.isTransfer;
        this.query.isHardStation = params.isHardStation ? params.isHardStation : params.isHardStation;
        this.populateVacantPosts();
      });

    this.getTransferRequest();
  }

  private getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
        this.transferRequest = response;
        this.populateVacantPosts();
        this.populatePreferences();
      }
      else {
        this.router.navigate(['/employee/transfer-request']);
      }
    });
  }

  getVacantPosts() {
    this.populateVacantPosts();
    this.populatePreferences();
  }

  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
  }


  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number) {
    this.commonService.getSchools(districtId, 1).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  private populateVacantPosts() {
    this.query.transferRequestId = this.transferRequest?.id;
    if (this.query.transferRequestId != undefined) {
      this.service.getVacantPosts(this.query)
        .subscribe((response: IPaged) => {
          if (response) {
            this.queryResult = response;
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.skeleton = false);
    }
  }

  private async populatePreferences() {
    this.queryPreference.transferRequestId = this.transferRequest?.id;
    await this.preferenceService.getPreferences(this.queryPreference)
      .subscribe((response: IPreference[]) => {
        if (response) {
          this.preferences = response;
          if (this.preferences.length > 0) {
            this.isSubmitEnable = true;
          } else {
            this.isSubmitEnable = false;
          }
        }
      });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }
    this.populateVacantPosts();
  }

  filter() {
    this.query.page = 1;
    this.router.navigate(['/employee/transfer-request/preference'], {
      queryParams: {
        page: this.query.page,
        sort: this.query.sort,
        sortDir: this.query.sortDir,
        regionId: this.query.regionId
      }
    });
  }

  add(item: IVacantPost) {
    this.loading = true;
    let preference: IPreference = {
      id: 0,
      order: 0,
      vacantPostId: item.id,
      transferRequestId: this.transferRequest.id
    }

    this.preferenceService.create(preference).subscribe(response => {
      if (response) {
        this.toastrService.success('preference added successfully');
        this.populateVacantPosts();
        this.populatePreferences();
      }
    }, (err) => console.log(err),
      () => this.loading = false);

  }
  // save() {
  //   this.transferRequest.isHardStation = this.query.isHardStation;
  //   this.transferRequest.isTransfer = this.query.isTransfer;
  //   this.transferRequest.id = this.query.id;
  //   this.transferRequest.profileId = this.query.profileId;
  //   this.transferRequest.financialYearId = this.setting.financialYearId;
  //   this.transferRequest.phaseId = this.setting.phaseId;
  //   if (this.query.id) {
  //     this.transferRequestService.updatePreferenceTransferRequest(this.query.id, this.transferRequest).subscribe((response: ITransferRequest) => {
  //       if (response && response.isTransfer) {
  //         this.transferRequest = response;
  //         this.router.navigate(['/employee/transfer-request/view']);
  //       }
  //       else if (response && !response.isTransfer) {
  //         this.transferRequest = response;
  //         this.router.navigate(['/employee/transfer-request/view']);
  //       }
  //     },
  //       (error) => console.log('HTTP Error', error),
  //       () => this.loading = false);
  //   }
  // }
}
